// DateRangeFilter.js
// import { ORDER_FILTER_KEYS } from '../Filter';
import { Box, useTheme } from '@mui/material';
import { tokens } from '../../../../../theme';
import { orderStateMap, orderRelationStateMap } from '../../../../../utils/labelColorText';
import { ORDER_FILTER_KEYS } from '../../Filter';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import cx from 'classnames'; // Importing cx from classnames
import { useDispatch, useSelector } from 'react-redux';
import { useGridFilter } from '../../../../../contexts/GridFilterContext';
import { updateFilter } from '../../../../../newapi/global/filter/gridFilterSlice';
import { general_states } from '../../../../../utils/staticEnums';

const OrderStatusFilter = ({ params }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const filterKey = ORDER_FILTER_KEYS.STATE.backend_key;
    const dispatch = useDispatch();

    const { index,id } = useGridFilter();
    const filterObject = useSelector((state) => {
        const instance = state.gridFilter.viewInstances[index];
        return instance ? instance[id] : undefined;
    });

    const allStates = params?.isRelation
        ? Object.values(orderRelationStateMap(theme))
        : params?.processStates
            ? Object.values(orderStateMap(theme)).filter(x => [general_states.OPEN, general_states.FULLYPICKED, general_states.ECHECK, general_states.PICKING_IN_PROGRESS].includes(x.state))
            : Object.values(orderStateMap(theme));

    const handleStateToggle = (itemState) => {
        if (filterObject && filterObject.filter) {
            const currentStates = filterObject.filter[filterKey] || [];

            // If isRelation and OPEN is clicked, toggle all processing states together
            if (params?.isRelation && itemState === general_states.OPEN) {
                const processingStates = [
                    general_states.OPEN,
                    general_states.ACTIVE,
                    general_states.PICKING_IN_PROGRESS,
                    general_states.FULLYPICKED,
                    general_states.REPLENISH,
                    general_states.ECHECKPAUSED,
                    general_states.TO_PROCESS,
                    general_states.PICKED,
                    general_states.ACTION_REQUIRED_WAREHOUSE
                ];

                // Check if OPEN is already in the filter
                const isActive = currentStates.includes(general_states.OPEN);

                let updatedStates;
                if (isActive) {
                    // Remove all processing states
                    updatedStates = currentStates.filter(state => !processingStates.includes(state));
                } else {
                    // Add all processing states
                    updatedStates = [...new Set([...currentStates, ...processingStates])];
                }

                dispatch(updateFilter({ index, id, filterKey, value: updatedStates }));
            } else {
                // Normal toggle behavior
                const updatedStates = currentStates.includes(itemState)
                    ? currentStates.filter(state => state !== itemState)
                    : [...currentStates, itemState];

                dispatch(updateFilter({ index, id, filterKey, value: updatedStates }));
            }
        }
    };
  
    return (
        <Box
            sx={{
                display:"flex",
                flexDirection:"column",
                gap:1.5,
            }}
        >
            {allStates.map((stateData,index) => {
                return (
                    <Box
                        className={cx({
                            active: filterObject && filterObject.filter?.[filterKey]?.includes(stateData.state), // Add the 'active' class if state is active
                        })}
                        onClick={() => handleStateToggle(stateData.state)}
                        key={index + stateData.labeltext}
                        sx={{
                            height:40,
                            border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] :colors.grey[100]}`,
                            p:0.5,
                            borderRadius:5,
                            display:"flex",
                            alignItems:'center',
                            "&.active " : {
                                background: colors[stateData.labelcolor][100],
                                border: `1px solid ${colors[stateData.labelcolor][100]}`,
                            }
                        }}
                    >
                        <Box
                            sx={{
                                height:32,
                                background: colors[stateData.labelcolor][100],
                                color: colors[stateData.labelcolor][400],
                                fontFamily:"Roboto, sans-serif",
                                fontSize:14,
                                fontWeight:500,
                                display:"inline-flex",
                                minWidth:120,
                                alignItems:"center",
                                justifyContent:"center",
                                borderRadius:4,
                            }}
                        >
                            {t(stateData.labeltext)}
                        </Box>

                    </Box>
                );
            })}
            
        </Box>
    );
};

export default OrderStatusFilter;